let DC = {};
let messageHandlers = {};
DC.registerMessageHandler = function (module, type, handler) {
  if (module && type && handler) {
    let handlerKey = module + '_' + type;
    if (!messageHandlers[handlerKey]) {
      messageHandlers[handlerKey] = new Set();
    }
    messageHandlers[handlerKey].add(handler);
  } else {
    console.error('handler error, handler is:' + handler);
  }
  return handler;
};

DC.unregisterMessageHandler = function (module, type, handler) {
  if (module && type && handler) {
    let handlerKey = module + '_' + type;
    if (!messageHandlers[handlerKey]) {
      console.error('unregister error: no handler handlerKey:' + handlerKey + 'handler:' + handler);
    }
    if (messageHandlers[handlerKey]) {
      messageHandlers[handlerKey].delete(handler);
    }
  } else {
    console.error('unregister handler error, handler is:' + handler);
  }
};
//注册全局的消息通道
DC.onmessage = function onmessage(message) {
  try {
    let data = window.JSON.parse(message.data);
    let module = data.msgModule; //模块名称
    let notifyType = data.notifyType; //消息类型
    let dataValue = data.data; //消息内容
    let handlerKey = module + '_' + notifyType;

    if (messageHandlers[handlerKey] && messageHandlers[handlerKey].size !== 0) {
      let handlers = messageHandlers[handlerKey];
      for (let item of handlers) {
        item(dataValue);
      }
    } else {}
  } catch (e) {
    console.error(e.toString());
  }
};

export default DC;
